import { CheckCircleOutlineIcon, ErrorOutlineIcon, InfoOutlineIcon, MagicWandOutlineIcon, WarningOutlineIcon } from '@applyboard/ui-icons';
import React from 'react';
import { Flex } from "../Flex";
import { InternalText } from "../InternalText";
import { IconWrapper } from "../IconWrapper";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * Optional guidance microcopy for input controls, including constraints, how the data will be used, or validation errors.
 */
export function HelpText(_ref) {
  var children = _ref.children,
    id = _ref.id,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'secondary' : _ref$intent,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon;
  var icons = {
    primary: InfoOutlineIcon,
    secondary: InfoOutlineIcon,
    positive: CheckCircleOutlineIcon,
    warning: WarningOutlineIcon,
    negative: ErrorOutlineIcon,
    magic: MagicWandOutlineIcon
  };
  var Icon = icons[intent];
  return _jsxs(Flex, {
    gap: showIcon ? 2 : 0,
    id: id,
    children: [showIcon && _jsx(IconWrapper, {
      allowInteractions: false,
      intent: intent,
      selector: "div",
      children: _jsx(Icon, {})
    }), _jsx(InternalText, {
      intent: intent,
      contrast: "mid",
      variant: "bodyS",
      children: children
    })]
  });
}